'use-strict'

import React from 'react'
import { Layer } from '../app'

import { DivTabs, DivTab, StyleSelectedTab } from '../styles'

interface Props {
    pages: Array<Layer>
    selectedPage: Number
    setSelectedPage: Function
    props: Object
}

function Tabs({ pages = [], selectedPage = 0, setSelectedPage, props = {} }: Props) {
    return (
        <DivTabs>
            {pages.map(({ name = 'Unknowed' }, i) => (
                <DivTab
                    key={i}
                    onClick={() => setSelectedPage(i)}
                    style={selectedPage === i ? { ...props, ...StyleSelectedTab } : props}
                >
                    {name}
                </DivTab>
            ))}
        </DivTabs>
    )
}

export default Tabs
